export const NumberLinePropPresets = {
    'IE': {
        label: 'IE',
        leftColor: '#0a6091',
        rightColor: '#92adc0',
        leanLeftLabel: 'Introverted',
        leanRightLabel: 'Extroverted',
        categoryLabel: 'Energy'
    },
    'SN': {
        label: 'SN',
        leftColor: '#0a6091',
        rightColor: '#92adc0',
        leanLeftLabel: 'Sensing',
        leanRightLabel: 'Intuition',
        categoryLabel: 'Mind'
    },
    'FT': {
        label: 'FT',
        leftColor: '#0a6091',
        rightColor: '#92adc0',
        leanLeftLabel: 'Feeling',
        leanRightLabel: 'Thinking',
        categoryLabel: 'Nature'
    },
    'JP': {
        label: 'JP',
        leftColor: '#0a6091',
        rightColor: '#92adc0',
        leanLeftLabel: 'Judging',
        leanRightLabel: 'Perceiving',
        categoryLabel: 'Tactics'
    },
    'AT': {
        label: 'AT',
        leftColor: '#0a6091',
        rightColor: '#92adc0',
        categoryLabel: 'Neuroticism',
        leanLeftLabel: 'Assertive',
        leanRightLabel: 'Turbulent'
    }
}